import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Container, Typography, styled } from "@mui/material";
import Footer from "../componentsPeopletech/Footer/Footer";

const CookiePolicy = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || "es";
  const baseUrl = "https://www.peoplefortech.com";

  const PolicyContainer = styled(Container)(({ theme }) => ({
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    backgroundColor: "#ffffff",
    maxWidth: "900px",
  }));

  const Title = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    fontSize: "2.5rem",
    marginBottom: theme.spacing(4),
    textAlign: "center",
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  }));

  const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    fontSize: "1.5rem",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    color: "#1c2859",
  }));

  const SectionText = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    lineHeight: 1.8,
    color: "#414141",
    marginBottom: theme.spacing(2),
  }));

  return (
    <>
      <Helmet>
        <title>Politica de Cookies - PeopleForTech</title>
        <meta
          name="description"
          content="Politica de Cookies de PeopleForTech para usuarios de la UE y del EEE."
        />
        <link rel="canonical" href={`${baseUrl}/cookie-policy`} />
        <html lang={currentLang} />
      </Helmet>

      <PolicyContainer>
        <Title variant="h1">Politica de Cookies</Title>

        <SectionText>
          En PeopleForTech usamos cookies y tecnologias similares para garantizar
          el funcionamiento del sitio web y, cuando lo autorizas, para analitica
          y marketing. Esta politica se aplica de acuerdo con el RGPD y la
          normativa europea y espanola sobre privacidad en comunicaciones
          electronicas.
        </SectionText>

        <SectionTitle variant="h2">1. Que son las cookies</SectionTitle>
        <SectionText>
          Las cookies son pequenos archivos que se almacenan en tu dispositivo
          al visitar un sitio web. Permiten recordar configuraciones, mejorar el
          rendimiento y obtener informacion de uso.
        </SectionText>

        <SectionTitle variant="h2">2. Tipos de cookies que usamos</SectionTitle>
        <SectionText component="ul" sx={{ pl: 4 }}>
          <li>
            <strong>Esenciales:</strong> necesarias para el funcionamiento
            tecnico del sitio (no se pueden desactivar desde el banner).
          </li>
          <li>
            <strong>Analitica:</strong> miden visitas, rendimiento y uso para
            mejorar la experiencia.
          </li>
          <li>
            <strong>Marketing:</strong> ayudan a personalizar contenido o
            comunicaciones promocionales.
          </li>
        </SectionText>

        <SectionTitle variant="h2">3. Base legal</SectionTitle>
        <SectionText>
          Las cookies esenciales se basan en el interes legitimo y necesidad
          tecnica del servicio. Las cookies de analitica y marketing solo se
          activan con tu consentimiento previo, libre e informado.
        </SectionText>

        <SectionTitle variant="h2">4. Como gestionar tu consentimiento</SectionTitle>
        <SectionText>
          Puedes aceptar, rechazar o personalizar cookies desde el banner. Tu
          decision se guarda localmente en tu navegador y puedes cambiarla
          eliminando cookies del navegador o solicitando actualizacion por email.
        </SectionText>

        <SectionTitle variant="h2">5. Tiempo de conservacion</SectionTitle>
        <SectionText>
          Conservamos la preferencia de consentimiento durante un periodo
          razonable para no mostrar el aviso en cada visita, salvo que borres los
          datos del navegador o cambien sustancialmente nuestras finalidades.
        </SectionText>

        <SectionTitle variant="h2">6. Contacto</SectionTitle>
        <SectionText>
          Para consultas sobre privacidad o cookies, escribe a:
          {" "}contact@peoplefortech.com
        </SectionText>
      </PolicyContainer>

      <Footer />
    </>
  );
};

export default CookiePolicy;

